<template>
  <div class="empty-state">
    <span class="icon">{{ icon }}</span>
    <b>{{ title }}</b>
    <p>{{ description }}</p>
  </div>
</template>

<script>
// 空白态：对齐线上版——写清楚"分析后会显示什么"，不放干巴巴的空页面
export default {
  name: 'EmptyState',
  props: {
    icon: { type: String, default: '🧠' },
    title: { type: String, required: true },
    description: String,
  },
};
</script>
